// https://gist.github.com/codeguy/6684588?permalink_comment_id=3332719#gistcomment-3332719

function useSlugify(text: string): string {
  return text
    .toString()
    .normalize('NFD') // split an accented letter in the base letter and the accent
    .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');
}

export default useSlugify;
